import React, { useRef, useState, useContext } from "react";
import HeaderButton from "../components/HeaderButton";
import { useDispatch } from "react-redux";
import {
  Dao,
  LendBorrow,
  Exchange,
  Farm,
  Budge,
  DisconnectArrow,
} from "../components/IconsSVG";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
import { Buy, confirmWallet, pageFarm } from "../redux/actions/modal";
import Slider from "react-slick";
import { Collapse } from "react-collapse";

import { Web3Context } from "../contexts/Web3Context";
import { connectToMetamask } from "../apis/blockchain";
import PopupRewards from "../components/Popups/PopupRewards";
import { BUY } from "../redux/modalsTypes";

export default function () {
  const Swal = require("sweetalert2");
  const [ref, setRef] = useState(null);
  const dispatch = useDispatch();
  const [showDisconnectButton, setShowDisconnectButton] = useState(false);
  const [showWallet, setShowWallet] = useState(
    localStorage.getItem("showWallet")
      ? JSON.parse(localStorage.getItem("showWallet"))
      : true
  );
  const web3Context = useContext(Web3Context);

  const hideWallet = () => {
    setShowWallet(!showWallet);
    localStorage.setItem("showWallet", !showWallet);
  };

  const connectWallet = async () => {
    await connectToMetamask(
      web3Context.web3.metamaskProvider,
      web3Context.isMetamaskConnected
    );
    localStorage.setItem("showWallet", true);
  };

  const formatAdddress = (address) => {
    return (
      address.substring(0, 5) + "..." + address.substring(address.length - 4)
    );
  };

  const settings = {
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: false,
    initialSlide: 0,
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    customPaging: (i) => {
      return <span className="header-slick-dot"></span>;
    },
    responsive: [
      {
        breakpoint: 656,
        settings: {
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: 0,
          swipeToSlide: true,
          cssEase: "linear",
          // adaptiveHeight: true,
        },
      },
    ],
  };

  return (
    <header className="header">
      <div className="header__wrapper">
        <div className="header-tn container">
          <div className="header-tn__left">
            <button
              className="header-tn__btn header-tn__btn_gradient header-tn__btn_rasko"
              onClick={() => dispatch(Buy())}
            >
              <span>Buy ASKO</span>
            </button>
            <a href="https://asko.finance/rasko">
              <button className="header-tn__btn header-tn__btn_gradient header-tn__btn_rasko">
                <span>Buy rASKO</span>
              </button>
            </a>
          </div>
          <div
            className="header-tn__right"
            onMouseLeave={() => setShowDisconnectButton(false)}
          >
            {web3Context.currentAccountAddress ? (
              <button className="header-tn__btn header-tn__btn_wallet">
                <img
                  src="/assets/images/header/wallet.png"
                  alt="wallet"
                  className="header-tn__icon"
                />
                <span>{formatAdddress(web3Context.currentAccountAddress)}</span>
              </button>
            ) : (
              <button
                className="header-tn__btn header-tn__btn_wallet"
                onClick={connectWallet}
              >
                <img
                  src="/assets/images/header/wallet.png"
                  alt="wallet"
                  className="header-tn__icon"
                />
                <span>Connect Wallet</span>
              </button>
            )}
          </div>
        </div>
        <nav className="header-nav">
          <div className="header-nav__center">
            <Slider {...settings} ref={(slider) => setRef(slider)}>
              <div className="header-nav__item">
                <HeaderButton
                  to="/voting"
                  name="DAO"
                  style={{ opacity: "0.6", pointerEvents:'none' }}
                  Icon={Dao}
                  onClick={() => ref.slickGoTo(1)}
                  // onClick={(e) => {
                  //   e.preventDefault(),
                  //     ref.slickGoTo(1),
                  //     Swal.fire({
                  //       imageUrl: "../assets/images/astr.png",
                  //       title: "Coming Soon",
                  //       showConfirmButton: false,
                  //     });
                  // }}
                />
              </div>
              <div className="header-nav__item">
                <HeaderButton
                  to="/trade"
                  name="Lend/Borrow"
                  Icon={LendBorrow}
                  onClick={() => ref.slickGoTo(2)}
                  // onClick={(e) => {
                  //   e.preventDefault(),
                  //     ref.slickGoTo(3),
                  //     Swal.fire({
                  //       imageUrl: "../assets/images/astr.png",
                  //       title: "Coming Soon",
                  //       showConfirmButton: false,
                  //     });
                  // }}
                />
              </div>
              <div className="header-nav__item">
                <HeaderButton
                  to="/swap"
                  name="Swap"
                  style={{ opacity: "0.6", pointerEvents:'none' }}
                  Icon={Exchange}
                  onClick={() => ref.slickGoTo(3)}
                  // onClick={(e) => {
                  //   e.preventDefault(),
                  //     ref.slickGoTo(3),
                  //     Swal.fire({
                  //       imageUrl: "../assets/images/astr.png",
                  //       title: "Coming Soon",
                  //       showConfirmButton: false,
                  //     });
                  // }}
                />
              </div>
              <div className="header-nav__item">
                <HeaderButton
                  to="/farm/"
                  name="Farms"
                  Icon={Farm}
                  onClick={() => {
                    dispatch(pageFarm());
                  }}
                />
              </div>
              <div className="header-nav__item">
                <HeaderButton
                  to="/rewards"
                  name="Borrower’s Rewards"
                  style={{ opacity: "0.6", pointerEvents:'none' }}
                  Icon={Budge}
                  onClick={() => ref.slickGoTo(5)}
                  // onClick={(e) => {
                  //   e.preventDefault(),
                  //     ref.slickGoTo(5),
                  //     Swal.fire({
                  //       imageUrl: "../assets/images/astr.png",
                  //       title: "Coming Soon",
                  //       showConfirmButton: false,
                  //     });
                  // }}
                />
              </div>
            </Slider>
          </div>
        </nav>
        <div className="header-pigs container">
          <div className="header-pigs__line">
            <picture className="header-pigs__img header-pigs__img_left">
              <source
                srcSet="/assets/images/header/pig.png 2x"
                type="image/png"
              />
              <source
                srcSet="/assets/images/header/pig.webp"
                type="image/webp"
              />
              <img src="/assets/images/header/pig.png" alt="pig" />
            </picture>
            <picture className="header-pigs__img header-pigs__img_right">
              <source
                srcSet="/assets/images/header/pig.png 2x"
                type="image/png"
              />
              <source
                srcSet="/assets/images/header/pig.webp"
                type="image/webp"
              />
              <img src="/assets/images/header/pig.png" alt="pig" />
            </picture>
          </div>
        </div>
      </div>
    </header>
  );
}
